import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Carousel, Typography } from "@material-tailwind/react";
import FaceMesh from "../assets/icons/FaceMesh3.svg";
import { ReactComponent as VendorLogo } from "../assets/logos/VendorLogo.svg";
// import { ReactComponent as CarePlixLogo } from "../assets/logos/CarePlix.svg";

const GetStarted = () => {
  const navigate = useNavigate();

  return (
    <section
      dir="ltr"
      className="relative grow shrink-0 bg-no-repeat bg-cover bg-black bg-center flex flex-col items-center text-white"
    >
      <div className="absolute top-[8%] right-[12%] -translate-y-1/2 translate-x-1/2 size-80 sm:size-[40rem] rounded-full bg-radial-gradient text-[#791ce1]" />
      <div className="absolute top-[15%] -left-[10%] -translate-x-1/2 size-[32rem] sm:size-[80rem] rounded-full bg-radial-gradient text-[#1545d6]" />
      <img
        src={FaceMesh}
        alt="Face Mesh Graphics"
        className="absolute left-0 top-[12.5%] h-3/4 w-3/5 -z-0 object-contain object-left"
      />
      <VendorLogo className="my-8 sm:my-16 h-8 sm:h-16 relative z-10" />
      <Carousel
        prevArrow={() => <></>}
        nextArrow={() => <></>}
        navigation={({ activeIndex, length }) => (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-stretch justify-between space-x-2 sm:space-x-4">
            {[...Array(length).keys()].map((i) => (
              <span
                key={`carousel-nav-${i}`}
                className={`shrink-0 h-2 w-2 sm:h-4 sm:w-4 lg:h-3.5 lg:w-3.5 rounded-full ${
                  activeIndex === i ? "bg-secondary" : "bg-white"
                }`}
              />
            ))}
          </div>
        )}
        autoplay
        autoplayDelay={3000}
        loop
        className="self-stretch grow items-center text-center whitespace-pre-line"
      >
        {[
          {
            title: "Futuristic\nHealth Monitoring",
            subtitle: "AI-Powered Face Scan\nfor Vital Insights",
          },
          {
            title: "60 Seconds to a\nHealthier You",
            subtitle: "Unlock Your Wellness\nPotential Now",
          },
        ].map((item, index) => (
          <Fragment key={`carousel-item-${index}`}>
            <Typography
              variant="h1"
              className="text-3xl sm:text-6xl leading-tight font-semibold"
            >
              {item.title}
            </Typography>
            <Typography
              variant="h2"
              className="mt-2.5 sm:mt-5 text-2xl sm:text-5xl leading-tight font-normal"
            >
              {item.subtitle}
            </Typography>
          </Fragment>
        ))}
      </Carousel>
      <Button
        size="lg"
        color="white"
        className="shrink-0 mt-6 sm:mt-12 mb-16 sm:mb-32 lg:mb-16 w-2/5 text-sm sm:text-2xl text-primary font-semibold normal-case relative z-50"
        onClick={() => navigate("/select-options")}
      >
        Get Started
      </Button>
    </section>
  );
};

export default GetStarted;
